import { Title, Stack } from "@mantine/core";
import { Area, CentroDeTrabajo, PuestoDeTrabajo, Turno } from ".";
import { TStaffSurveyDataELSA5 } from "../../../types";

type Props = {
  form: any;
  survey: TStaffSurveyDataELSA5;
  setIsLeader: (isLeader: boolean) => void;
};

export const InformacionLaboralPersonalizable = ({
  form,
  survey,
  setIsLeader,
}: Props) => {
  return (
    <Stack spacing="lg">
      <Title order={3}>Información Laboral</Title>
      {survey.staff_survey.flag_005 && (
        <Turno form={form} turnos={survey.work_shifts} />
      )}
      {survey.staff_survey.flag_007 && (
        <Area form={form} areas={survey.areas} />
      )}
      <PuestoDeTrabajo
        form={form}
        puestos={survey.jobs}
        setIsLeader={setIsLeader}
        useDefaultJobs={!survey.staff_survey.flag_008}
      />
      {survey.staff_survey.flag_009 && (
        <CentroDeTrabajo form={form} centros={survey.workplaces} />
      )}
    </Stack>
  );
};
